@if (component?.gallery_id) {
@if (hasContent) {
<div class="wrap">
      <div class="w-12 center h1"
           [ngClass]="component.copy ? 'm-b-1' : 'm-b-2'"
           *iCms="'title' of component; content: 'html'; skipEmpty: true"></div>

      <div class="w-12 center p1 m-b-2"
           *iCms="'copy' of component; content: 'html'; skipEmpty: true"></div>
</div>
}

<curalate-gallery class="curalate-gallery overflow-hidden"
                  [filter]="filter"
                  [galleryId]="component.gallery_id"
                  (loaded)="onLoaded($event)" />
}